
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import PeriodsContent from './Components/PeriodsContent.vue';

export default defineComponent({
  name: "PeriodsPage",
  components: {
    BreadCrumb,
    PeriodsContent
 
  },
});
